import { useMemo, useReducer } from 'react'
import type { Dispatch } from 'react'
import experienceOfferPageStateReducer, {
  INITIAL_EXPERIENCE_PAGE_STATE,
  type ExperienceOfferPageDispatchAction,
  type ExperienceOfferPageState,
} from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateReducer'

export interface TripExperienceInitialState {
  date?: string
  time?: string
  ticketCounts?: Record<string, number>
  redemptionLocationId?: string
  pickupPointId?: string
}

function buildInitialState(
  override?: TripExperienceInitialState,
  standaloneOffer?: App.ExperienceOffer,
): ExperienceOfferPageState {
  if (!override) return INITIAL_EXPERIENCE_PAGE_STATE
  return {
    ...INITIAL_EXPERIENCE_PAGE_STATE,
    date: override.date,
    time: override.time,
    ticketCounts: override.ticketCounts ?? {},
    redemptionLocation: standaloneOffer?.redemptionLocations?.find(l => l.id === override.redemptionLocationId),
    pickupPoint: standaloneOffer?.pickupPoints?.find(p => p.id === override.pickupPointId),
  }
}

type ReturnType = [ExperienceOfferPageState, Dispatch<ExperienceOfferPageDispatchAction>]

function useTripExperiencePageState(
  initialOverride?: TripExperienceInitialState,
  standaloneOffer?: App.ExperienceOffer,
): ReturnType {
  const [state, dispatch] = useReducer(
    experienceOfferPageStateReducer,
    INITIAL_EXPERIENCE_PAGE_STATE,
    (_base: ExperienceOfferPageState) => buildInitialState(initialOverride, standaloneOffer),
  )
  return useMemo(() => [state, dispatch] as ReturnType, [state, dispatch])
}

export default useTripExperiencePageState
